import { Component, NgZone } from "@angular/core";
import {
  IonicPage,
  NavController,
  App,
  LoadingController,
  ActionSheetController,
  Events
} from "ionic-angular";
import { SignInPage } from "../sign-in/sign-in";
import firebase from "firebase";
import { AuthService } from "../../services/AuthService";
import { FirestoreService } from "../../services/FirestoreService";

@IonicPage()
@Component({
  selector: "page-profile",
  templateUrl: "profile.html"
})
export class ProfilePage {
  userName: string = "";
  userPicture: string = "";
  email: string = "";
  isSubscribed: boolean = false;
  showSubscriptionStatus: boolean = false;
  checkingSubscription = true;

  constructor(
    private navCtrl: NavController,
    private app: App,
    private loadingCtrl: LoadingController,
    private zone: NgZone,
    private firestoreService: FirestoreService,
    public actionSheetCtrl: ActionSheetController,
    private events: Events,
    private authService: AuthService
  ) {

    this.authService.afAuth.user.subscribe(user => {
      this.userName = user.displayName;
      this.userPicture = user.photoURL;
      this.email = user.email;
      console.log(user);
    });

    this.checkIfSubscribed();

    this.events.subscribe('hasSubscribed', (hasSubscribed) => {
      this.checkIfSubscribed();
    })
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad ProfilePage");
  }

  goToUsers() {
    this.navCtrl.push("UsersPage");
  }


  goToAccount() {
    this.navCtrl.push("AccountPage");
  }

  renewSubscription() {
    this.navCtrl.push("SubscriptionsPage");
  }



  goToNotifications() {
    this.navCtrl.push("NotificationsPage");
  }

  goToMyList() {
    this.navCtrl.push("MylistPage");
  }

  myDevices() {
    this.navCtrl.push("MyDevicesPage");
  }

  goToSettings() {
    this.navCtrl.push("SettingsPage");
  }

  pay() {
    this.navCtrl.push("SubscriptionsPage");
  }

  watchHistory() {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'My Watch History',
      buttons: [
        {
          text: 'Watched Movies',
          role: 'destructive',
          handler: () => {
            this.navCtrl.push("WatchedMoviesPage");
          }
        },{
          text: 'Watched TV Shows',
          handler: () => {
            this.navCtrl.push("WatchedShowsPage");
          }
        },{
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  checkIfSubscribed() {
    this.checkingSubscription = true;
    let uid = localStorage.getItem('loggedInUserUID')
    this.firestoreService
      .checkIfSubscribed(uid)
      .then((result: any) => {
        this.isSubscribed = result.isSubscribed;
        this.showSubscriptionStatus = true
        this.checkingSubscription = false;
      });
  }

  signOut() {
    var loading = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Logging out...'
    });

    loading.present();
    let uid = localStorage.getItem('loggedInUserUID');
            let uuid = localStorage.getItem('deviceUuid');
            this.authService.handleAccountLoginsOnLogout();
            this.firestoreService.removeDeviceWithUUID(uid, uuid)

    //this.authService.signOut();

    setTimeout(() => {
      loading.dismiss();

      firebase
        .auth()
        .signOut()
        .then(() => {
          this.zone.run(() => {

            this.app.getRootNav().setRoot(SignInPage);
          });
        });
    }, 3000);
  }

  signOutForce() {
    this.authService.signOutForce();
  }



}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts